"use client";

import { useEffect, useState } from "react";

export const useSecurityCheck = () => {
  const [isInIframe, setIsInIframe] = useState(false);
  const [securityWarnings, setSecurityWarnings] = useState<string[]>([]);

  useEffect(() => {
    const warnings: string[] = [];
    const hostname = window.location.hostname;

    // 🔒 Detect if page is loaded in iframe (clickjacking protection)
    if (window.top !== window.self) {
      setIsInIframe(true);
      warnings.push("Page loaded in iframe - potential clickjacking attempt");
      console.warn("⚠️ Security Warning: Clickjacking attempt detected");
    }

    // 🟢 DEFINE SAFE LOCAL ENVIRONMENTS
    const isLocalEnvironment = 
      hostname === "localhost" || 
      hostname === "127.0.0.1" || 
      hostname.endsWith(".localhost"); // This allows hackathon.localhost!

    // 🔒 Check if HTTPS is being used in production
    // If it's NOT a local environment, and it's NOT https, throw a warning.
    if (!isLocalEnvironment && window.location.protocol !== "https:") {
      warnings.push("Insecure connection detected");
    }

    setSecurityWarnings(warnings);
  }, []);

  return { isInIframe, securityWarnings };
};